import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectGlobalCommunityListItems } from "../../../../../redux/dbn-cloud/global-community/selector";
import { globalCommunity } from "../../../../../redux/dbn-cloud/global-community/action";
import { selectListItems } from "../../../../../redux/library/selector";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { communities } from "../../../../../redux/community/action";
import { communitySubscriptions } from "../../../../../redux/community-subscriptions/action";


const AgencyGlobalCommunities = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const libraryData = useSelector(selectListItems)
    const [pageData, setPageData] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const globalCommunityItemsData = useSelector(selectGlobalCommunityListItems);
    const [columnDefs, setColumnDefs] = useState({});

    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(params.node.id, 10) + 1;
                },
            },
            {
                field: 'DBNIEName', headerName: 'DBNIE Name', searchField: 'DBNIEName', filter: true,
                filterType: 'text'
            },
            {
                field: 'Name', headerName: 'Community Name', searchField: 'Name', filter: true,
                filterType: 'text'
            },
            {
                field: 'DBAName', headerName: 'DBA Name', searchField: 'DBAName', filter: true,
                filterType: 'text'
            },
            { field: 'IsTrainingAvailable', headerName: 'Training Available', cellRenderer: 'yesNoRenderer' },
            {
                field: 'CommunityStatusId',
                headerName: 'Community Status',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CommunityStatus },
                //isRowColorDecider: true,
                sortable: true,
                filter: true,
                filterType: 'text',
                filterBy: libraryData?.result?.CommunityStatus,
                align: 'text-center'
            },
        ]);
    };

    const fetchGlobalCommunityList = () => {
        dispatch(globalCommunity.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/global-communities/list`,
            entity: 'globalCommunity',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc"
            }
        }));
    };

    useEffect(() => {
        createColumnDefs();
        fetchGlobalCommunityList();
    }, [pageData, pageSize]);


   
   
    const handleReloadData = () => {
        fetchGlobalCommunityList()
    }
    const additionButtons: any = [
    
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            callback: () => handleReloadData(),
        },
    ];

    const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column,
                FieldText: data?.column,
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }

        dispatch(globalCommunity.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/global-communities/list`,
            entity: 'globalCommunity',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
            }
        }));
    };

const handleSubscribe = async (data: any) => {
    await dispatch(communitySubscriptions.resetAction({ actionType: 'create' }));
    await dispatch(communitySubscriptions.create({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/communities/subscribe`,
      entity: 'communitySubscriptions',
      jsonData: {
       
        Records: [
          {
            Id: data.Id,
            
          }
        ]
      }
    })).then(() => {
      fetchGlobalCommunityList();
    });
  };

    return (
        <>
            {globalCommunityItemsData?.isLoading ?
                <PageLoader /> :
                <Table
                    checkboxConfig={{
                        allowMultiSelect: true,
                        defaultSelectedIds: [],
                        isDisabled: false,
                        keyColumn: 'Id',
                    }}
                    IsSubscribe={true} handleSubscribe={handleSubscribe}
                    columnData={columnDefs}
                    rowData={globalCommunityItemsData?.result?.items}
                    setPageData={setPageData}
                    setPageSize={setPageSize}
                    enableFilter={true}
                    onSearch={handleSearch}
                    paginationData={globalCommunityItemsData?.result?.pagination}
                    additionButtons={additionButtons}
                    headingName="Global Community"
                />
            }
        </>
    );
};

export default AgencyGlobalCommunities;
